import { render, staticRenderFns } from "./ViberBrandNameCommitTransaction.vue?vue&type=template&id=78465bc6"
import script from "./ViberBrandNameCommitTransaction.vue?vue&type=script&lang=js"
export * from "./ViberBrandNameCommitTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports